export type Phase = 1 | 2 | 3 | 4

export function monthsLeft(examDate: string, today: Date = new Date()): number {
  const [ey, em, ed] = examDate.split('-').map(Number)
  const y = today.getFullYear()
  const m = today.getMonth() + 1
  const d = today.getDate()
  const total = (ey - y) * 12 + (em - m) + (ed - d) / 30
  return Math.max(0, total)
}

export function currentPhase(examDate: string, today: Date = new Date()): Phase {
  const t = monthsLeft(examDate, today)
  if (t > 4) return 1
  if (t > 2) return 2
  if (t > 0.5) return 3
  return 4
}

export const PHASE_LABELS: Record<Phase, string> = {
  1: 'Konu fazı',
  2: 'Soru fazı',
  3: 'Deneme fazı',
  4: 'Sprint',
}
